/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getAllMenuContents() {
  const provinceContents = document.querySelectorAll('main-menu[data-province-menu] .main-menu__content');
  if (provinceContents.length > 0) return Array.from(provinceContents);
  const single = document.querySelector('.main-menu__content');
  return single ? [single] : [];
}

if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.isPaused = false;

      this.bindEvents();
      this.init();
    }

    disconnectedCallback() {
      if (this.moveLinksHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.moveLocalizationHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }
    }

    bindEvents() {
      if (this.links) {
        this.moveLinksHandler = this.moveLinksHandler || this.moveLinks.bind(this);
        window.addEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.localization) {
        this.moveLocalizationHandler = this.moveLocalizationHandler
          || debounce(this.moveLocalization.bind(this));
        window.addEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }

      if (this.slider) {
        this.slider.addEventListener('mouseenter', this.pauseSlider.bind(this));
        this.slider.addEventListener('mouseleave', this.resumeSlider.bind(this));
      }
    }

    /**
     * Start sliders a slidin'
     */
    init() {
      if (this.slider) {
        const slides = this.slider.querySelectorAll('.announcement__text');
        slides[0].classList.add('is-visible');

        const nextSlide = () => {
          if (!this.isPaused && theme.elementUtil.isInViewport(this)) {
            const currSlide = this.slider.querySelector('.announcement__text.is-visible');
            const currSlideIndex = Array.from(currSlide.parentNode.children)
              .indexOf(currSlide);
            const nextSlideIndex = currSlideIndex + 1 < slides.length ? currSlideIndex + 1 : 0;

            if (document.dir === 'rtl') {
              this.slider.scrollTo(
                -Math.abs(nextSlideIndex * slides[nextSlideIndex].clientWidth),
                0
              );
            } else {
              this.slider.scrollTo(slides[nextSlideIndex].offsetLeft - 32, 0);
            }

            slides[nextSlideIndex].classList.add('is-visible');
            slides[currSlideIndex].classList.remove('is-visible');
          }

          setTimeout(nextSlide, this.dataset.slideDelay);
        };
        setTimeout(nextSlide, this.dataset.slideDelay);
      }

      if (this.links) {
        this.moveLinks();
      }

      if (this.localization) {
        this.moveLocalization();
      }
    }

    /**
     * Move the help links to all main menus (both province menus when present). On desktop, remove them.
     */
    moveLinks() {
      const allLinks = document.querySelectorAll('.mob__announcement-links');
      if (theme.mediaMatches.md) {
        allLinks.forEach((el) => el.remove());
        return;
      }

      const menuContents = getAllMenuContents();
      if (!menuContents.length || !this.links.length) return;

      allLinks.forEach((el) => el.remove());

      const mobNav = document.createElement('nav');
      mobNav.classList.add('mob__announcement-links');
      const mobNavUl = document.createElement('ul');
      mobNavUl.classList.add('secondary-nav');
      this.links.forEach((link) => {
        mobNavUl.innerHTML += `<li><a class="secondary-nav__item" href="${link.href}">${link.innerText}</a>`;
      });
      mobNav.appendChild(mobNavUl);

      menuContents.forEach((content, i) => {
        content.appendChild(i === 0 ? mobNav : mobNav.cloneNode(true));
      });
    }

    /**
     * Move the localization block to all main menus (both when province menus exist). On desktop, put it back in the announcement bar.
     */
    moveLocalization() {
      this.localization = this.querySelector('.announcement__localization');
      const allMobLocalizations = document.querySelectorAll('.mob__localization');

      if (theme.mediaMatches.md) {
        const first = document.querySelector('.mob__localization');
        if (first && this.localization) {
          this.localization.appendChild(first.firstElementChild);
        }
        allMobLocalizations.forEach((el) => el.remove());
        return;
      }

      const menuContents = getAllMenuContents();
      if (!menuContents.length || !this.localization) return;

      const firstMob = document.querySelector('.mob__localization');
      if (firstMob && firstMob.firstElementChild) {
        this.localization.appendChild(firstMob.firstElementChild);
      }
      allMobLocalizations.forEach((el) => el.remove());

      const form = this.localization.firstElementChild;
      if (!form) return;

      menuContents.forEach((content, i) => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('mob__localization');
        wrapper.appendChild(i === 0 ? form : form.cloneNode(true));
        content.appendChild(wrapper);
      });

      const p = document.body.dataset.province;
      if (p === 'ON' || p === 'OTHER') {
        document.querySelectorAll('[data-province-select]').forEach((sel) => {
          if (sel.value !== p) sel.value = p;
        });
      }
    }

    /**
     * Pauses the auto-rotating slider
     */
    pauseSlider() {
      this.isPaused = true;
    }

    /**
     * Resumes the auto-rotating slider
     */
    resumeSlider() {
      this.isPaused = false;
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
